import React from 'react';
import { Link } from 'react-router-dom';
import { aboutContent, testimonials } from '../mock';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Star, CheckCircle } from 'lucide-react';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1 className="about-hero-title">{aboutContent.title}</h1>
          <p className="about-hero-subtitle">{aboutContent.subtitle}</p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story-section">
        <div className="about-story-grid">
          <div className="about-story-image">
            <img src="https://images.unsplash.com/photo-1630057135574-6ac3a75fbdf7" alt="Our Story" />
          </div>
          <div className="about-story-content">
            <h2 className="about-story-title">Who We Are</h2>
            <p className="about-story-text">{aboutContent.description}</p>
            <div className="about-mission">
              <h3 className="about-mission-title">Our Mission</h3>
              <p className="about-mission-text">{aboutContent.mission}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-values-section">
        <h2 className="about-values-title">Our Core Values</h2>
        <div className="about-values-grid">
          {aboutContent.values.map((value, index) => (
            <Card key={index} className="about-value-card">
              <div className="about-value-icon">
                <CheckCircle size={32} />
              </div>
              <h3 className="about-value-title">{value.title}</h3>
              <p className="about-value-description">{value.description}</p>
            </Card>
          ))}
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="about-testimonials-section">
        <h2 className="about-testimonials-title">What Our Customers Say</h2>
        <div className="about-testimonials-grid">
          {testimonials.map(testimonial => (
            <Card key={testimonial.id} className="testimonial-card">
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-comment">"{testimonial.comment}"</p>
              <div className="testimonial-footer">
                <p className="testimonial-name">{testimonial.name}</p>
                <p className="testimonial-product">{testimonial.product}</p>
              </div>
            </Card>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <h2 className="about-cta-title">Start Your Wellness Journey</h2>
        <p className="about-cta-text">Explore our collection of natural products crafted with care</p>
        <Button asChild size="lg" className="about-cta-button">
          <Link to="/shop">Shop Now</Link>
        </Button>
      </section>
    </div>
  );
};

export default About;
